import { MenuItem } from 'primereact/menuitem';
import { Steps, StepsSelectParams } from 'primereact/steps';
import WrapperButton from '../../../../components/buttons/WrapperButton';
import ConfirmationDialog from '../../../../components/messages/ConfirmationDialog';
import React from 'react';

type TimesheetBundleSteps = {
  index: number;
  changeIndex: (number: number) => void;
  removeReimbursement: () => void;
};

const TimesheetBundleSteps = ({
  index,
  changeIndex,
  removeReimbursement,
}: TimesheetBundleSteps) => {
  const items = [
    {
      label: 'Timesheet',
      command: (event: StepsSelectParams) => {
        changeIndex(event.index);
      },
    },
    {
      template: () => {
        return (
          <a
            href={'test'}
            className="p-menuitem-link"
            role="presentation"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              const targetElement = event.target as HTMLElement;
              const parentLink = targetElement.closest('a.p-menuitem-link');

              if (parentLink && targetElement.localName !== 'i') {
                changeIndex(1);
              }
            }}
          >
            <span className="p-steps-number">2</span>
            <span className="p-steps-title flex gap-2 align-items-center">
              Petty Cash Reimbursement
              <ConfirmationDialog
                tagKey="draft-remove-reimbursement"
                Button={
                  <WrapperButton className="h-fit m-auto">
                    <i className="pi pi-trash text-17px p-1 border-circle hover:bg-gray-300" />
                  </WrapperButton>
                }
                onConfirm={removeReimbursement}
                message={
                  <React.Fragment>
                    <div className='blackText'>
                      Do you want to remove the Petty Cash Reimbursement?
                    </div>
                    <div className='errorText text-base mt-1'>
                      Removing the Reimbursement won't affect the Timesheet
                      values.
                    </div>
                  </React.Fragment>
                }
              />
            </span>
          </a>
        );
      },
    },
  ];

  return (
    <Steps
      model={items}
      activeIndex={index}
      readOnly={false}
      className="steps-db-bg"
    />
  );
};

export default TimesheetBundleSteps;
